import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getRedirects   = (params, token)      => Axios.get("/api/v1/admin/blog/redirects", { params, ...h(token) });
export const createRedirect = (data, token)        => Axios.post("/api/v1/admin/blog/redirects", data, h(token));
export const updateRedirect = (id, data, token)    => Axios.put(`/api/v1/admin/blog/redirects/${id}`, data, h(token));
export const deleteRedirect = (id, token)          => Axios.delete(`/api/v1/admin/blog/redirects/${id}`, h(token));
